<template>
  <div class="hire-manager">
    <div class="top-title">租户管理</div>
    <!-- <Card dis-hover> -->
    <ul class="common-search li-margin">
      <li>
        <span>租户名称: </span>

        <Input
          v-model="dataForm.companyName"
          name="ccompanyName"
          @on-search="(e) => searchInput(e, 'companyName')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>公司税号: </span>
        <Input
          v-model="dataForm.dutyParagraph"
          @on-search="(e) => searchInput(e, 'dutyParagraph')"
          search
          placeholder="请输入"
        />
      </li>
      <!-- <li>
        <span>租户ID: </span>
        <Input
          v-model="dataForm.id"
          @on-search="(e) => searchInput(e, 'id')"
          search
          placeholder="请输入"
        />
      </li> -->
      <li>
        <span>租户类型: </span>
        <Select
          v-model="dataForm.type"
          @on-change="(e) => changeSel(e, 'type')"
          :clearable="true"
          placeholder="全部"
        >
          <Option value="0">经销商</Option>
          <Option value="1">客户</Option>
        </Select>
      </li>
      <li>
        <span>租户状态: </span>
        <Select
          v-model="dataForm.status"
          @on-change="(e) => changeSel(e, 'status')"
          :clearable="true"
          placeholder="全部"
        >
          <Option value="0">未开通</Option>
          <Option value="1">使用中</Option>
          <!-- <Option value="2">已过期</Option> -->
        </Select>
      </li>
      <li class="dataPicker">
        <span>开通时间: </span>
        <DatePicker
          @on-change="(e) => changeDateOpen(e, 'openDate')"
          :clearable="false"
          v-model="dataForm.openDate"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择"
        />
      </li>
      <li class="dataPicker">
        <span>到期时间: </span>
        <DatePicker
          @on-change="(e) => changeDateExpire(e, 'expireDate')"
          :clearable="false"
          v-model="dataForm.expireDate"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择"
        />
      </li>

      <li class="searchItem">
        <!-- <Button type="primary" class='sels-item' @click="getLists(1)" shape="circle" icon="ios-search">搜索</Button>
                    &nbsp;&nbsp; -->
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle" />
      </span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="lists clearfix list-margin">
      <!-- &nbsp;&nbsp; -->
      <Button type="primary" id="addHire" @click="addHire()">
        <Icon type="md-add" /> 新增租户
      </Button>
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          ref="selection"
          :columns="dataColumn"
          :data="dataLists"
          @on-selection-change="selTableChange"
        >
        </Table>
      </div>
      <Button :disabled="hireStatus" @click="setActive()"> 开通 </Button>
      <!-- 分页器 -->

      <div class="common-page fr" v-if="pageInfo.total">
        <!-- <Page show-total :total="pageInfo.total" :current="pageInfo.current" :page-size="pageInfo.size" @on-change="getLists"></Page> -->
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="changeSize"
        ></Page>
      </div>
    </div>
    <!-- </Card> -->

    <HireDrawer
      ref="hireDrawer"
      :closeDrawer="closeDrawer"
      :showDrawer="showDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
    >
    </HireDrawer>
    <!-- <IndicatorVisible
     :clearclick="clartindiact" 
     :iniobj="iniobj"
      :showDrawer="indiaShow" 
      v-if="fioption" 
      :fioption="fioption" /> -->
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import moment from "moment";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import HireDrawer from "./components/hire-drawer.vue";
import HireModal from "@/components/hire/hire-modal.vue";
import sizeData from "@/mixins/sizeData";
import IndicatorVisible from "./components/IndicatorVisible.vue";
import {
  getidFiconPage,
  detailByTenant,
  testTenant,
} from "@/api/knowledge/lubtionment";

export default {
  name: "hire-manager",
  mixins: [handleSelItem, sizeData],
  components: {
    HireDrawer,
    HireModal,
    IndicatorVisible,
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
    }),
  },
  data() {
    return {
      userRole: ls.get("userRole"),
      iniobj: {},
      indiaShow: false,
      hireId: this.$router.history.current.query.hid,
      hireName: this.$router.history.current.query.hname,
      dataLists: [],
      selItems: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      showDrawer: false,
      hireModalPop: false,
      curItemDetail: {},
      selTableItems: [],
      hireStatus: true,
      fioption: null,
      dataColumn: [
        {
          type: "selection",
          width: 80,
          align: "left",
          fixed: "left",
        },
        {
          title: "序号",
          type: "index",
          width: 80,

          fixed: "left",
        },
        {
          title: "租户公司名称",
          key: "companyName",
          width: 200,
          fixed: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.companyName || "-");
          },
        },
        {
          title: "公司税号",
          key: "dutyParagraph",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.dutyParagraph || "-");
          },
        },
        // {
        //   title: "租户ID",
        //   key: "id",
        //   width: 200,
        //   render: (h, params) => {
        //     const item = params.row;
        //     return h("div", item.id || "-");
        //   },
        // },
        {
          title: "租户类型",
          key: "type",
          width: 100,
          render: (h, params) => {
            const item = params.row;
            return h("div", +item.type === 1 ? "客户" : "经销商");
          },
        },
        {
          title: "租户用户数",
          key: "userCount",
          width: 120,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.userCount || "-");
          },
        },
        // {
        //     title: "租户状态",
        //     key: "status",
        //     width: 100,
        //     render: (h, params) => {
        //         const item = params.row;
        //         let statusName = "--";
        //         if (+item.status === 0) statusName = "未开通";
        //         else if (+item.status === 1) statusName = "使用中";
        //         else statusName = "-";
        //         return h("div", statusName);
        //     },
        // },

        {
          title: "租户状态",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                params.row.status == 1 ? "使用中" : "未开通"
              ),
              h(
                "i-switch",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    value: params.row.status,
                    "true-value": 1,
                    "false-value": 0,
                    beforeChange: this.handleBeforeChange,
                    "true-color": "#1E8E3E ",
                  },
                  on: {
                    "on-change": (value) => {
                      // 状态更新
                      this.selTableItems = [];
                      this.selTableItems.push(params.row.id);
                      if (value == 1) this.setActive();
                      else this.coloseActive();
                    },
                  },
                  nativeOn: {
                    mousedown: () => {
                      // 监听组件原生事件mousedown,此事件在click之前触发
                      this.switchOneInfo = {
                        value: params.row.status,
                      };
                    },
                  },
                },
                ""
              ),
            ]);
          },
        },
        {
          title: "报警短信通知",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                params.row.tenantSmsAlarm == 1 ? "已启用" : "已禁用"
              ),
              h(
                "i-switch",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    value: Number(params.row.tenantSmsAlarm),
                    "true-value": 1,
                    "false-value": 0,

                    beforeChange: this.handleBeforeChange1,
                    "true-color": "#1E8E3E ",
                  },
                  on: {
                    "on-change": (value) => {
                      // 状态更新

                      this.batchUser({
                        ids: [params.row.id],
                        tenantSmsAlarm: value,
                      });
                    },
                  },
                  nativeOn: {
                    mousedown: () => {
                      // 监听组件原生事件mousedown,此事件在click之前触发
                      this.switchOneInfo = {
                        value: params.row.status,
                      };
                    },
                  },
                },
                ""
              ),
            ]);
          },
        },
        {
          title: "测试租户",
          width: 150,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {},
              },
              [
                h("div", {
                  style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "114px",
                    height: "21px",
                    "z-index": 1000,
                    cursor: "pointer",
                  },
                  // on: {
                  //  "click":()=>{
                  //   this.handleBeforeChange2({
                  //       ids: [params.row.id],
                  //       testTenant: params.row.testTenant==0?1:0
                  //     })
                  //  }
                  // }
                }),
                h(
                  "span",
                  {
                    style: {
                      marginRight: "8px",
                    },
                  },
                  params.row.testTenant == 1 ? "是" : "否"
                ),
              ]
            );
          },
        },

        {
          title: "本次开通时间",
          key: "openDate",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.openDate || "-");
          },
        },
        {
          title: "本次到期时间",
          key: "expireDate",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.expireDate || "-");
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },

        {
          title: "操作",

          align: "left",
          fixed: "right",
          width: 200,
          className: "action",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  "align-items": "center",
                  "z-index": "100",
                  position: "relative",
                },
              },
              [
                h(
                  "div",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.editDetail(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "div",
                  {
                    props: {
                      size: "small",
                    },
                    class: "del",
                    style: {
                      color: "#0c479d", //"#ed4014"
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.delItemWarning(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ]
            );
          },
        },
      ],
    };
  },
  created() {
    this.init();
    if (this.hireName) {
      this.dataForm.companyName = this.hireName;
      this.searchInput(this.hireName, "companyName");
    } else {
      this.getLists();
    }
  },

  methods: {
    async batchtestTenant(row) {
      let data = await testTenant(row);
      this.$Message.success("处理成功");
      this.getLists();
    },
    clartindiact() {
      this.iniobj = {};
      this.indiaShow = false;
    },
    async init() {
      let userRole = this.userRole;

      if (!(userRole == "m0" || userRole == "m1")) {
        let index = this.dataColumn.findIndex((e) => e.title == "测试租户");
        this.dataColumn.splice(index, 1);
      }
      // let data = await getidFiconPage({
      //   current: 1,
      //   size: 999
      // })
      // this.fioption = data.data.records 
    },
    batchUser(obj) {
      api.axss("post", "/ocm-admin/tenant/open/alarmSms", obj).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("处理成功");
          this.getLists();
        }
      });
    },
    handleBeforeChange2(row) {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: "您确定要切换测试租户的状态吗",

          onOk: () => {
            // resolve();
            this.batchtestTenant(row);
          },
        });
      });
    },
    handleBeforeChange1() {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: "您确定要切换短信通知状态吗？",

          onOk: () => {
            resolve();
          },
        });
      });
    },
    getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理
      let dataFormCopy = deepcopy(this.dataForm);
      delete dataFormCopy.openDate;
      delete dataFormCopy.expireDate;
      if (this.hireId) dataFormCopy.id = this.hireId;

      api
        .axss("post", "/ocm-admin/tenant/page", {
          ...this.pageInfo,
          ...dataFormCopy,
        })
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data;
            this.dataLists = datas.records;
            this.dataLists.forEach((item, index) => {
              if (+item.status !== 0) this.dataLists[index]._disabled = true;
              if (item.type == 1) {
                this.dataLists[index]._tupedisabled = true;
              } else {
                this.dataLists[index]._tupedisabled = false;
              }
            });
            this.pageInfo.total = datas.total;
          }
          this.$store.state.spinShow = false;
        });
    },
    changeSize(data) {
      this.pageInfo.size = data;
      this.getLists();
    },
    handleBeforeChange() {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: "您确定要切换租户状态吗？",
          onOk: () => {
            resolve();
          },
        });
      });
    },
    // 选中table项
    selTableChange(items) {
      this.selTableItems = items.map((res) => res.id);
      if (this.selTableItems.length) this.hireStatus = false;
      else this.hireStatus = true;
    },
    setActive() {
      if (this.selTableItems.length === 0)
        return this.$Message.info("请至少选择一个租户");
      api
        .axss("post", "/ocm-admin/tenant/open", {
          ids: this.selTableItems,
        })
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("开通成功");
            this.hireStatus = true;
            this.getLists();
          }
        });
    },
    coloseActive() {
      if (this.selTableItems.length === 0)
        return this.$Message.info("请至少选择一个租户");
      api
        .axss("post", "/ocm-admin/tenant/close", {
          id: this.selTableItems[0],
        })
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("关闭成功");
            this.getLists();
          }
        });
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeDate(date, name) {
      this.dataForm.gmtCreateDateStart = date[0];
      this.dataForm.gmtCreateDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    changeDateOpen(date, name) {
      this.dataForm.openDateStart = date[0];
      this.dataForm.openDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    changeDateExpire(date, name) {
      this.dataForm.expireDateStart = date[0];
      this.dataForm.expireDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      this.dataForm[selItem.name] = null;

      // 删除跳转时的名称
      if (this.hireName === selItem.val) {
        delete this.dataForm.companyName;
        this.hireId = null;
        this.$router.push("/hire/hiremanager");
      }

      // 日期需要单独处理

      if (selItem.name === "expireDate") {
        delete this.dataForm.expireDateStart;
        delete this.dataForm.expireDateEnd;
      }
      if (selItem.name === "openDate") {
        delete this.dataForm.openDateStart;
        delete this.dataForm.openDateEnd;
      }

      this.selItems.splice(index, 1);

      this.getLists(1);
    },
    addHire() {
      this.curItemDetail = {}; // 重置form
      this.showDrawer = true;
    },
    editDetail(item) {
      this.curItemDetail = deepcopy(item);
      this.showDrawer = true;
    },
    delItemWarning(item) {
      this.curItemDetail = deepcopy(item);

      let title = "您确定要删除该租户吗？";
      let content = `<div style="color:#000;font-weight: bold;" >租户名称：${item.companyName}</div>
            <div>建议您在该租户到期后再进行删除操作。</div> `;
      if (item.state === 1) {
        content = `<div style="color:#000;font-weight: bold;" >租户名称：${item.companyName}[使用中]</div>
            <div>建议您在该租户到期后再进行删除操作。</div> `;
      }

      this.$Modal.confirm({
        title: title,
        content,
        onOk: () => {
          this.delItem();
        },
        onCancel: () => {},
      });
    },
    delItem() {
      api
        .axss("post", `/ocm-admin/tenant/del/${this.curItemDetail.id}`)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            this.curItemDetail = {};
            const finalSize = this.sizeData(
              this.pageInfo.size,
              this.pageInfo.current,
              this.pageInfo.total
            );
            this.getLists(finalSize);
          }
        });
    },
    closeDrawer() {
      this.showDrawer = false;
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.curItemDetail = {};
      });
    },
    closeModal() {
      this.hireModalPop = false;
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });

      // 额外删除传输的客户
      delete this.dataForm.companyName;
      this.hireId = null;
      this.$router.push("/hire/hiremanager");
    },
  },
};
</script>

<style lang="less" scoped>
.hire-manager {
  .lists {
    margin-top: 20px;
  }
}
</style>
